<p-dialog
  header="Modifier les causes potentielles"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', 'max-width': '800px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onCancel()"
>
  <div class="edit-potential-causes-modal">
    <div class="modal-content">
      <form [formGroup]="form">
        <div formArrayName="potentialCauses" class="causes-list">
          <div
            *ngFor="
              let causeGroup of potentialCausesArray.controls;
              let i = index
            "
            [formGroupName]="i"
            class="cause-row"
            [ngClass]="{ deleted: !isVisibleRow(i) }"
            [style.display]="isVisibleRow(i) ? 'flex' : 'none'"
          >
            <div class="cause-description">
              <input
                type="text"
                pInputText
                formControlName="description"
                placeholder="Description de la cause"
                [class.ng-invalid]="
                  causeGroup.get('description')?.invalid &&
                  causeGroup.get('description')?.touched
                "
              />
              <small
                *ngIf="
                  causeGroup.get('description')?.invalid &&
                  causeGroup.get('description')?.touched
                "
                class="error-message"
              >
                La description est requise
              </small>
            </div>

            <div class="cause-percentage">
              <p-inputNumber
                formControlName="percentage"
                [min]="0"
                [max]="100"
                suffix="%"
                [showButtons]="true"
                [step]="1"
                [class.ng-invalid]="
                  causeGroup.get('percentage')?.invalid &&
                  causeGroup.get('percentage')?.touched
                "
              ></p-inputNumber>
              <small
                *ngIf="
                  causeGroup.get('percentage')?.invalid &&
                  causeGroup.get('percentage')?.touched
                "
                class="error-message"
              >
                Le pourcentage doit être entre 0 et 100
              </small>
            </div>

            <div class="cause-actions">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-trash"
                class="p-button-danger p-button-sm p-button-outlined"
                (click)="deleteAt(i)"
                [disabled]="potentialCausesArray.length <= 1"
              ></button>
            </div>
          </div>

          <div class="add-cause-section">
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-plus"
              label="Ajouter une cause"
              class="p-button-secondary p-button-outlined"
              (click)="addNew()"
            ></button>
          </div>
        </div>
      </form>

      <div *ngIf="!isFormValid" class="validation-warning">
        <div class="warning-content">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ validationMessage }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button
        type="button"
        pButton
        pRipple
        label="Annuler"
        class="p-button-text"
        (click)="onCancel()"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        label="Enregistrer"
        class="p-button-primary"
        (click)="onSubmit()"
        [disabled]="!isSubmissionAllowed"
      ></button>
    </div>
  </ng-template>
</p-dialog>
<p-confirmdialog 
  [style]="{ 'max-width': '800px', 'min-width': '400px' }"
  styleClass="custom-confirm-dialog"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
/>

<p-dialog
  header="Ajustement automatique des pourcentages"
  [(visible)]="showAdjustmentDialog"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  styleClass="percentage-adjustment-dialog"
>
  <div class="space-y-6" *ngIf="adjustmentData">
    <div class="flex items-center gap-4 p-4 bg-gradient-to-r from-yellow-100 to-yellow-200 border border-yellow-400 rounded-lg mb-6">
      <i class="pi pi-exclamation-triangle text-2xl text-yellow-600 animate-pulse-custom"></i>
      <div class="flex-1">
        <p class="m-0 font-medium text-yellow-800">
          La somme des pourcentages n'est pas égale à 100% 
          <span 
            class="inline-block px-2 py-1 ml-2 text-sm font-semibold rounded"
            [ngClass]="adjustmentData.difference > 0 ? 'bg-cyan-100 text-cyan-800 border border-cyan-300' : 'bg-red-100 text-red-800 border border-red-300'"
          >
            ({{ adjustmentData.difference > 0 ? '+' : '' }}{{ adjustmentData.difference }}%)
          </span>
        </p>
      </div>
    </div>

    <div *ngIf="adjustmentData.changedItems.length > 0 && adjustmentData.unchangedItems.length > 0" class="mb-6">
      <h4 class="flex items-center gap-2 mb-4 text-lg font-semibold text-gray-800">
        <i class="pi pi-pencil text-blue-600"></i>
        Éléments modifiés par vous
      </h4>
      <p class="mb-4 text-gray-600 leading-relaxed" *ngIf="hasChangedItemsBeingAdjusted()">
        Certains éléments modifiés seront aussi ajustés pour atteindre 100% :
      </p>
      <p class="mb-4 text-gray-600 leading-relaxed" *ngIf="!hasChangedItemsBeingAdjusted()">
        Ces éléments resteront aux valeurs que vous avez définies :
      </p>
      <div class="space-y-2">
        <div 
          *ngFor="let item of adjustmentData.changedItems" 
          class="flex items-center justify-between p-3 bg-gradient-to-r from-blue-50 to-cyan-50 border border-blue-200 rounded-lg transform transition-transform"
        >
          <span class="font-medium text-gray-800">{{ item.description }}</span>
          <div class="flex items-center gap-2" *ngIf="item.newValue !== undefined && item.newValue !== item.currentValue; else noAdjustment">
            <span class="text-gray-500 line-through font-mono text-sm">{{ item.currentValue }}%</span>
            <i class="pi pi-arrow-right text-blue-600 text-sm"></i>
            <span class="font-semibold text-blue-700 bg-blue-100 px-2 py-1 rounded border border-blue-200 font-mono text-sm">
              {{ item.newValue }}%
            </span>
          </div>
          <ng-template #noAdjustment>
            <span class="font-semibold text-blue-800 font-mono text-sm">{{ item.currentValue }}%</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="adjustmentData.unchangedItems.length > 0" class="mb-6">
      <h4 class="flex items-center gap-2 mb-4 text-lg font-semibold text-gray-800">
        <i class="pi pi-arrows-h text-blue-600"></i>
        Ajustements automatiques proposés
      </h4>
      <p class="mb-4 text-gray-600 leading-relaxed">
        Les éléments non modifiés seront ajustés comme suit :
      </p>
      <div class="space-y-2">
        <div 
          *ngFor="let item of adjustmentData.unchangedItems" 
          class="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-lg transform transition-transform "
        >
          <span class="font-medium text-gray-800">{{ item.description }}</span>
          <div class="flex items-center gap-2">
            <span class="text-gray-500 line-through font-mono text-sm">{{ item.currentValue }}%</span>
            <i class="pi pi-arrow-right text-blue-600 text-sm"></i>
            <span class="font-semibold text-green-700 bg-green-100 px-2 py-1 rounded border border-green-200 font-mono text-sm">
              {{ item.newValue }}%
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="adjustmentData.unchangedItems.length === 0 && adjustmentData.changedItems.length > 0" class="mb-6">
      <h4 class="flex items-center gap-2 mb-4 text-lg font-semibold text-gray-800">
        <i class="pi pi-arrows-h text-blue-600"></i>
        Ajustements égaux pour tous les éléments
      </h4>
      <p class="mb-4 text-gray-600 leading-relaxed">
        Tous les éléments ont été modifiés et seront ajustés proportionnellement pour atteindre 100% :
      </p>
      <div class="space-y-2">
        <div 
          *ngFor="let item of adjustmentData.changedItems" 
          class="flex items-center justify-between p-3 bg-gradient-to-r from-yellow-50 to-orange-50 border border-orange-200 rounded-lg transform transition-transform "
        >
          <span class="font-medium text-gray-800">{{ item.description }}</span>
          <div class="flex items-center gap-2">
            <span class="text-gray-500 line-through font-mono text-sm">{{ item.currentValue }}%</span>
            <i class="pi pi-arrow-right text-orange-600 text-sm"></i>
            <span class="font-semibold text-orange-700 bg-orange-100 px-2 py-1 rounded border border-orange-200 font-mono text-sm">
              {{ item.newValue }}%
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center gap-4 p-4 bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-lg mt-6">
      <i class="pi pi-question-circle text-2xl text-blue-600 animate-bounce-custom"></i>
      <p class="m-0 font-medium text-gray-800">Voulez-vous continuer avec ces ajustements automatiques ?</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
      <button
        type="button"
        pButton
        pRipple
        label="Annuler"
        icon="pi pi-times"
        class="p-button-text p-button-secondary"
        (click)="cancelAdjustment()"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        label="Appliquer les ajustements"
        icon="pi pi-check"
        class="p-button-primary"
        (click)="acceptAdjustment()"
      ></button>
    </div>
  </ng-template>
</p-dialog>